export default "/assets/images/pair-your-mila.webp?8ac20057725c2ffe6833fffc7211739a";